import cookies from 'js-cookie';
import queueCoxAutoDataLayer from "./queueCoxAutoDataLayer";
import { getExperimentIds } from './utils/googleAnalytics/getExperimentIds';
export const queue = (currentWindow, params) => {
  currentWindow._pixall_queue = currentWindow._pixall_queue || [];
  currentWindow._pixall_queue.push(params);
};
const getPageAndGlobalValues = ({
  dataLayer,
  params,
  props = {},
  isPageView
}) => {
  if (dataLayer.pixall && dataLayer.pixall.eventSource && !isPageView) {
    params.eventSource = dataLayer.pixall.eventSource;
  }
  if (dataLayer?.testids) {
    params.abTestId = getExperimentIds(dataLayer.testids);
  }
  if (dataLayer.pageinstance) {
    params.pageInstanceId = dataLayer.pageinstance;
  }
  if (dataLayer.analytics) {
    params.omnitureSuperSection = dataLayer.analytics.supersectionname;
    params.omnitureSectionName = dataLayer.analytics.sectionname;
    params.omnitureDetailedPageName = params.omnitureDetailedPageName || dataLayer.analytics.detailpagename;
  }
  if (dataLayer.googleanalytics && dataLayer.googleanalytics.ico && dataLayer.googleanalytics.ico.offerCode) {
    if (dataLayer.googleanalytics.ico.offerCode !== 'unknown') {
      params.cdl = {
        eventProperties: {
          ico: {
            offerCode: dataLayer.googleanalytics.ico.offerCode
          }
        }
      };
    }
  }
  if (dataLayer.info) {
    if (dataLayer.info.manufacturer && dataLayer.info.manufacturer.name) {
      params.make = dataLayer.info.manufacturer.name;
    }
    if (dataLayer.info.model && dataLayer.info.model.name) {
      params.model = dataLayer.info.model.name;
    }
    if (dataLayer.info.category) {
      params.bodyStyle = dataLayer.info.category;
    }
    if (dataLayer.info.yearid) {
      params.year = dataLayer.info.yearid;
    }
    if (dataLayer.info.bodyStyle) {
      params.bodyStyle = dataLayer.info.bodyStyle;
    }
    if (dataLayer.info.vehicle && dataLayer.info.vehicle.id) {
      params.vehicleId = dataLayer.info.vehicle.id;
    }
    if (dataLayer.info.intent) {
      params.vehicleType = dataLayer.info.intent === 'buy-new' || dataLayer.info.intent === 'buynew' ? 'new' : 'used';
    }
    if (dataLayer.info.pricingreporttype && dataLayer.info.pricingreporttype === 'buyused-cpo') {
      params.vehicleType = 'certified';
    }
    if (dataLayer.info.vehicle && dataLayer.info.vehicle.taggingprice) {
      if (typeof dataLayer.info.vehicle.taggingprice === 'string') params.price = dataLayer.info.vehicle.taggingprice.split('^')[0];else params.price = dataLayer.info.vehicle.taggingprice;
    }
    if (dataLayer.info.odometer) {
      params.odometer = dataLayer.info.odometer;
    }
    if (dataLayer.info.exteriorcolor && dataLayer.info.exteriorcolor.length > 2) {
      params.exteriorColor = dataLayer.info.exteriorcolor;
    }
    if (dataLayer.info.fueleconomy) {
      params.fuelEconomy = dataLayer.info.fueleconomy;
    }
    if (dataLayer.info.chromeStyleIds && dataLayer.info.chromeStyleIds.length > 0) {
      if (typeof dataLayer.info.chromeStyleIds === "object") {
        params.chromeStyleId = dataLayer.info.chromeStyleIds[0];
      } else {
        params.chromeStyleId = dataLayer.info.chromeStyleIds;
      }
    }
  }
  if (dataLayer.currentview == 'classifiedslistings' && location.queryString.color) {
    params.exteriorColor = location.queryString.color.split('|');
  }
  return {
    ...params,
    ...props
  };
};
const pageView = function (currentWindow, dataLayer, {
  isInitialLoad = true,
  props
} = {}) {
  var params = {
    pageType: 'unmatched',
    ...dataLayer.pixall
  };
  if (params.eventSource) {
    delete params.eventSource;
  }
  params.type = isInitialLoad ? 'meta-data' : 'event';
  if (!isInitialLoad) {
    params.eventType = 'ajaxPageView';
  }
  if (dataLayer.analytics && dataLayer.analytics.pagename) {
    if (!isInitialLoad) {
      params.omnitureDetailedPageName = props?.detailPageName;
    }
    params.pageName = dataLayer.analytics.pagename;
  }
  if (dataLayer.location && dataLayer.location.zip) {
    params.searchFacetZipCode = dataLayer.location.zip;
  }
  const paramsWithPageGlobalData = getPageAndGlobalValues({
    dataLayer,
    params,
    props,
    isPageView: true
  });
  queueCoxAutoDataLayer({
    dataLayer
  });
  queue(currentWindow, paramsWithPageGlobalData);
};
const click = (currentWindow, dataLayer, {
  getPageGlobalValues = false,
  props
} = {}) => {
  if (getPageGlobalValues) {
    var params = {
      type: 'event',
      eventType: 'click',
      pageId: dataLayer.pageId || dataLayer.pixall?.pageId,
      zipCode: dataLayer.location.zip
    };
    const paramsWithPageGlobalData = getPageAndGlobalValues({
      dataLayer,
      params,
      props
    });
    queue(currentWindow, paramsWithPageGlobalData);
  } else {
    queue(currentWindow, {
      type: 'event',
      eventType: 'click',
      pageId: dataLayer.pageId,
      pageInstanceId: dataLayer.pageinstance,
      zipCode: dataLayer.location.zip,
      ...props
    });
  }
};
const impression = (currentWindow, dataLayer, {
  vehicleListingType,
  getPageGlobalValues = false,
  props
} = {}) => {
  var params = {
    type: 'event',
    eventType: 'impression',
    pageId: dataLayer.pageId || dataLayer.pixall?.pageId,
    pageInstanceId: dataLayer.pageinstance,
    zipCode: dataLayer.location.zip
  };
  if (getPageGlobalValues) {
    params = getPageAndGlobalValues({
      dataLayer,
      params,
      props
    });
  } else {
    params = {
      ...params,
      ...props
    };
  }
  if (props?.vehicles?.length) {
    const pageSize = 25;
    props.vehicles.forEach(vehicle => {
      vehicle.listingType = vehicle.listingType || vehicleListingType;
    });
    for (let startIndex = 0; startIndex < props.vehicles.length; startIndex += pageSize) {
      queue(currentWindow, {
        ...params,
        vehicles: props.vehicles.slice(startIndex, startIndex + pageSize)
      });
    }
  } else {
    queue(currentWindow, params);
  }
};
const processQueue = currentWindow => {
  currentWindow._pxan = currentWindow._pxan || [];
  if (currentWindow._pixall_queue) {
    currentWindow._pixall_queue.forEach(data => {
      currentWindow._pxan.push(data);
    });
  }
  currentWindow._pixall_queue = [];
  currentWindow._pixall_queue.push = data => {
    currentWindow._pxan.push(data);
  };
};
const initialize = currentWindow => {
  if (typeof window !== 'undefined') {
    const start = Date.now();
    const waitForPixall = () => {
      if (Date.now() - start <= 10000) {
        if (window.Pixall) {
          processQueue(currentWindow);
          if (!cookies.get('pxa_realid') && cookies.get('pxa_id')) {
            cookies.set('pxa_realid', cookies.get('pxa_id'), {
              expires: 365
            });
          }
        } else {
          setTimeout(waitForPixall, 500);
        }
      }
    };
    waitForPixall();
  }
};
const updateCdl = data => {
  if (typeof window !== 'undefined') {
    globalThis.coxAutoDataLayer = globalThis.coxAutoDataLayer || [];
    globalThis.coxAutoDataLayer.push(data);
  }
};
export default {
  initialize,
  pageView,
  click,
  impression,
  updateCdl
};